import { Box, ButtonBase } from '@mui/material';

interface Option {
  label: string;
  value: string;
}

interface Props {
  options: Option[];
  value: string;
  onChange: (value: string) => void;
}

export default function CalendarViewToggle({
  options,
  value,
  onChange,
}: Props) {
  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '2px',
        p: '2px',
        border: '1px solid #000',
        borderRadius: '5px',
        height: 42,
        boxSizing: 'border-box',
      }}>
      {options.map(option => {
        const selected = option.value === value;
        return (
          <ButtonBase
            key={option.value}
            onClick={() => onChange(option.value)}
            sx={{
              height: 32,
              px: 2,
              borderRadius: '3px',
              fontFamily: 'inherit',
              backgroundColor: selected ? '#000' : 'transparent',
              color: selected ? '#fff' : 'text.primary',
              transition: 'background-color 120ms ease, color 120ms ease',
              typography: 'h5',
              fontWeight: 700,
            }}>
            {option.label}
          </ButtonBase>
        );
      })}
    </Box>
  );
}
